var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notranslate",class:_vm.headerMessage ? 'e3-quill-header' : ''},[(_vm.headerMessage)?_c('div',{staticClass:"main-gradient border border-bottom-0 rounded-top p-2"},[_vm._v(_vm._s(_vm.headerMessage))]):_vm._e(),_c('div',{ref:"editor"}),_c('ValitationMessages',{attrs:{"validation":_vm.validation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }